import { useFollowingNichesQuery } from "@/common/queries/queries";
import { useCallback, useEffect, useState } from "react";
import { INiche } from "@/common/services/types";

export const useFollowingNiche = () => {
  const [following, setFollowing] = useState<string[]>([]);

  const my = useFollowingNichesQuery({
    previews: false,
    options: { cacheTime: 0 }
  });

  useEffect(() => {
    if (my.status === "success" && my.data !== undefined) {
      const ids = my.data.niches.map((niche: INiche): string => {
        return niche.id;
      });

      setFollowing(ids);
    }
  }, [my.status, my.data]);

  const isFollowing = useCallback((id: string): boolean => {
    return following.indexOf(id) >= 0;
  }, [following]);

  const addFollowing = useCallback((id: string): void => {
    setFollowing((prev) => [...prev, id]);
  }, []);

  const removeFollowing = useCallback((id: string): void => {
    setFollowing((prev) => {
      return prev.filter((x) => x !== id);
    });
  }, []);

  const onFollow = useCallback((id: string, status: boolean): void => {
    if (status) {
      addFollowing(id);
    } else {
      removeFollowing(id);
    }
  }, [addFollowing, removeFollowing]);

  return {
    onFollow,
    isFollowing,
    following
  };
};
